import { render, staticRenderFns } from "./configureGetLinkTemplate.vue?vue&type=template&id=373fa342&scoped=true"
import script from "./configureGetLinkTemplate.vue?vue&type=script&lang=js"
export * from "./configureGetLinkTemplate.vue?vue&type=script&lang=js"
import style0 from "./configureGetLinkTemplate.vue?vue&type=style&index=0&id=373fa342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373fa342",
  null
  
)

export default component.exports